import { all, fork, put, takeLatest } from 'redux-saga/effects';
import * as types from './types';
import * as Api from '../../api/concreteClasses';
import callToAPI from '../../../utils/callToAPI';

function* getConcreteClasses100({ payload }) {
  yield callToAPI({
    apiCall: Api.getConcreteClasses100,
    successResponseCode: 200,
    errorType: types.GET_CONCRETE_CLASSES_100_ERROR,
    *callback({ data }) {
      yield put({
        type: types.GET_CONCRETE_CLASSES_100_SUCCESS,
        payload: {
          data: data.data || data,
          total: data.total || (data.data || data).length,
        },
      });
    },
    payload,
  });
}

function* watchGetConcreteClasses100() {
  yield takeLatest(
    types.GET_CONCRETE_CLASSES_100_REQUEST,
    getConcreteClasses100,
  );
}

export default function* rootSaga() {
  yield all([fork(watchGetConcreteClasses100)]);
}
